<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateCalendar"
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          ref="formWizard"
          class="custom-padding-wz-header"
          title
          subtitle
        >
          <tab-content
            :title="$t('common_words.details')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.association')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center">
              3.1 {{ $t('common_words.verify_inputed_information') }}
            </p>
            <div class="row d-flex justify-content-center">
              <div class="col-9">
                <payment-calendar-details-table
                  :isCreateOrEdit="true"
                  :calendarData="model"
                />
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <not-index-permissions v-else />
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import FirstStep from './steps/FirstStep.vue';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SecondStep from './steps/SecondStep.vue';
import TableDetails from 'src/views/Pages/Dashboard/PaymentCalendar/TableDetails.vue';

export default {
  components: {
    FirstStep,
    SecondStep,
    [TableDetails.name]: TableDetails,
  },

  data() {
    return {
      title: '',
      model: {
        name: null,
        yearSel: moment().format('Y'),
        init_dates_week: { [moment().format('Y')]: [] },
        end_dates_week: { [moment().format('Y')]: [] },
        years: [Number.parseInt(moment().format('Y'))],
        periocity: { [moment().format('Y')]: null },
        businessSelected: [],
        farmsSelected: [],
      },
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinMenu],

  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = {
        name: null,
        yearSel: moment().format('Y'),
        init_dates_week: { [moment().format('Y')]: [] },
        end_dates_week: { [moment().format('Y')]: [] },
        years: [Number.parseInt(moment().format('Y'))],
        periocity: { [moment().format('Y')]: null },
      };
      this.$refs.firstStep.flagPeriocity = null;
      this.$refs.firstStep.periods = { [moment().format('Y')]: 0 };
      this.$refs.secondStep.model = { business_ids: null, farm_ids: null };
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(_, model) {
      this.model = { ...this.model, ...model };
      if (this.model.step === 2) {
        const toObjectArray = (arr, key) =>
          arr.map((value) => ({ [key]: value }));

        this.model.farms = toObjectArray(this.model.farmsSelected, 'name');
        this.model.businesses = toObjectArray(
          this.model.businessSelected,
          'name'
        );
        this.model.years = toObjectArray(this.model.years, 'year');
      }
    },

    storeUpdateCalendar() {
      this.showHideLoading(true);
      this.model.route = 'works/paymentcalendars';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.model.id = JSON.parse(sessionStorage.getItem('editForm')).id;

          Axios.updateMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/works/paymentcalendars',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/works/paymentcalendars',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('works');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('works');
  },
};
</script>
